<template>
  <div style="overflow:hidden;">
    <v-row no-gutters>
      <v-col cols="12" class="mobile-history-header elevation-3">
        <v-row no-gutters>
          <v-col cols="1" class="px-2">
            <v-icon class="mobile-history-header-back" @click="goToMobileAcc" large>mdi-chevron-left</v-icon>
          </v-col>
          <v-col cols="9" class="mobile-history-header-mid">
            <span class="header-mid-label">{{ $t(`label.history`) }}</span>
          </v-col>
          <v-col  cols="2"></v-col>
        </v-row>
      </v-col>
    </v-row>

<!--    <v-row class="hidden-md-and-up" style="height:75px;align-items: center;">-->
<!--      <v-col cols="12" class=" mobile-header elevation-3">-->
<!--        <v-row no-gutters>-->
<!--          <v-col cols="1" class="">-->
<!--            <span>back</span>-->
<!--          </v-col>-->
<!--          <v-col cols="10" class=" text-center ">-->
<!--            {{ $t(`label.history`) }}-->
<!--          </v-col>-->
<!--        </v-row>-->
<!--      </v-col>-->


<!--      <v-col class="mobile-header">-->
<!--        back-->
<!--      </v-col>-->
<!--      <v-col cols="10" class="mobile-header text-center elevation-3">-->
<!--        {{ $t(`label.history`) }}-->
<!--      </v-col>-->
    </v-row>

<!--    new mobile ui history filter-->
    <v-row v-if="false" no-gutters>
      <v-col cols="4" class="mobile-filter-col">
        <v-menu bottom :offset-y="true">
          <template v-slot:activator="{ on, attrs }">
            <v-card class="mobile-menu-card-wrapper-promotion">
              <v-btn v-bind="attrs" v-on="on" block class="mobile-category-menuBtn-promotion">
                {{ selectedCategory }}
                <v-icon right large>mdi-menu-down</v-icon>
              </v-btn>
            </v-card>
          </template>
          <v-list>
            <!--            <v-list-item @click="">-->
            <!--              {{ $t(`label.all`) }}-->
            <!--            </v-list-item>-->
            <v-list-item v-for="category in translatedCategories" :key="category.id" @click="naviToSubHistory(category)">
              <router-link :to="category.routeName" style="text-decoration: unset !important;width: 100%;">
                <span>{{ category.name }}</span>
              </router-link>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-col>

      <!--      betting history  gametype filter dropdown-->
      <v-col v-if="isBetHistory" cols="4" class="mobile-filter-col">
        <v-menu bottom :offset-y="true">
          <template v-slot:activator="{ on, attrs }">
            <v-card class="mobile-menu-card-wrapper-promotion">
              <v-btn v-bind="attrs" v-on="on" block class="mobile-category-menuBtn-promotion">
                <span>{{ selectedGameTypeTranslation }}</span>
                <v-icon right large>mdi-menu-down</v-icon>
              </v-btn>
            </v-card>
          </template>
          <v-list @click="gameTypeOnChanged('OVERVIEW')">
            <v-list-item>
              <span style="text-transform: capitalize;">{{ $t(`label.all`) }}</span>
            </v-list-item>
          </v-list>
          <v-list v-for="(n, k) in providerTypes" :key="n.id" @click="gameTypeOnChanged(n)">
            <v-list-item>
              <span style="text-transform: capitalize;">{{ $t(`label.${n.type.toLowerCase()}`) }}</span>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-col>

      <!--      betting history  provider filter dropdown-->
      <v-col v-if="isBetHistory" cols="4" class="mobile-filter-col">
        <v-menu bottom :offset-y="true">
          <template v-slot:activator="{ on, attrs }">
            <v-card class="mobile-menu-card-wrapper-promotion">
              <v-btn v-bind="attrs" v-on="on" block class="mobile-category-menuBtn-promotion">
                <span>{{ selectedProvider ? selectedProvider : $t(`label.provider`) }}</span>
                <v-icon right large>mdi-menu-down</v-icon>
              </v-btn>
            </v-card>
          </template>

          <v-list v-for="provider in providerDdl" :key="provider.value" @click="providerFilterOnChanged">
            <v-list-item>
              <span>{{ provider.text }}</span>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-col>
    </v-row>


    <!--    <v-card style="border-radius: unset" class="mt-4">-->
    <!--      <v-row justify="left" no-gutters>-->
    <!--        <v-col cols="4">-->

    <!--          &lt;!&ndash;          <v-menu>&ndash;&gt;-->
    <!--          &lt;!&ndash;            <template v-slot:activator="{ on, attrs }">&ndash;&gt;-->
    <!--          &lt;!&ndash;              <v-card class="mobile-menu-card-wrapper">&ndash;&gt;-->
    <!--          &lt;!&ndash;                <v-btn v-bind="attrs" v-on="on" block class="mobile-category-menuBtn">&ndash;&gt;-->
    <!--          &lt;!&ndash;                  {{ selectedCategory }}&ndash;&gt;-->
    <!--          &lt;!&ndash;                  <v-icon right large>mdi-menu-down</v-icon>&ndash;&gt;-->
    <!--          &lt;!&ndash;                </v-btn>&ndash;&gt;-->
    <!--          &lt;!&ndash;              </v-card>&ndash;&gt;-->
    <!--          &lt;!&ndash;            </template>&ndash;&gt;-->
    <!--          &lt;!&ndash;            <v-list>&ndash;&gt;-->
    <!--          &lt;!&ndash;              <v-list-item v-for="category in translatedCategories" :key="category.id"&ndash;&gt;-->
    <!--          &lt;!&ndash;                           @click="naviToSubHistory(category)" style="width: 100%">&ndash;&gt;-->
    <!--          &lt;!&ndash;                <router-link :to="category.routeName" style="text-decoration: unset !important;width: 100%;">&ndash;&gt;-->
    <!--          &lt;!&ndash;                  <span>{{ category.name }}</span>&ndash;&gt;-->
    <!--          &lt;!&ndash;                </router-link>&ndash;&gt;-->
    <!--          &lt;!&ndash;              </v-list-item>&ndash;&gt;-->
    <!--          &lt;!&ndash;            </v-list>&ndash;&gt;-->
    <!--          &lt;!&ndash;          </v-menu>&ndash;&gt;-->
    <!--        </v-col>-->
    <!--      </v-row>-->
    <!--    </v-card>-->
    <v-row>
      <v-col cols="12" class="historyContainer">
        <router-view></router-view>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { uiHelper, locale } from '@/util'
import { ROUTE_NAME } from '@/constants/route.constants'
import { CACHE_KEY } from '@/constants/constants'

export default {
  name: 'mobileHistory',
  data: () => ({
    selectedCategory: '',
    HistoryCategories: [],
    routeName: ROUTE_NAME,
    showBetHistoryFilter: false,
    showTurnoverHistoryFilter: false,
    showWalletHistoryFilter: false,
    selectedGameType: 'OVERVIEW',
    selectedGameTypeTranslation: locale.getMessage(`label.all`),
    selectedProvider: '',
    isBetHistory: false
    // seletedTab: '',
    // historyTypes: [
    //   {
    //     type: 'betting',
    //     name: locale.getMessage('mobileMenuTitle.betHistory'),
    //     page: ROUTE_NAME.MOBILE_BETTING_HISTORY,
    //     id: 1
    //   },
    //   {
    //     type: 'turnover',
    //     name: locale.getMessage('label.turnoverHistory'),
    //     page: ROUTE_NAME.MOBILE_TO_HISTORY,
    //     id: 2
    //   },
    //   {
    //     type: 'wallet',
    //     name: locale.getMessage('mobileMenuTitle.walletHistory'),
    //     page: ROUTE_NAME.MOBILE_TRANSACTION_HISTORY,
    //     id: 3
    //   }
    // ]
  }),
  computed: {
    translatedCategories() {
      let categories = [
        {
          name: locale.getMessage('mobileMenuTitle.betHistory'),
          routeName: this.routeName.MOBILE_BETTING_HISTORY,
          id: 1
        },
        {
          name: locale.getMessage('label.turnoverHistory'),
          routeName: this.routeName.MOBILE_TO_HISTORY,
          id: 2
        },
        {
          name: locale.getMessage('mobileMenuTitle.walletHistory'),
          routeName: this.routeName.MOBILE_TRANSACTION_HISTORY,
          id: 3
        }
        // {
        //   name: 'Promotion History',
        //   routeName: this.routeName.MOBILE_PROMO_HISTORY,
        //   id: 4
        // }
      ]

      return categories
    },
    providerTypes() {
      return this.$store.state.game.ProviderTypes
    },
    providerDdl() {
      let tab = 'cricket' //this.selectedGameType
      let type = ''
      switch (tab) {
        case 'rng':
          type = 'rng'
          break
        case 'sb':
          type = 'sb'
          break
        case 'ld':
          type = 'ld'
          break
        case 'cricket':
          type = 'cricket'
          break
        case 'table':
          type = 'table'
          break
        case 'fishing':
          type = 'fishing'
          break
        case 'crash':
          type = 'crash'
          break
      }

      let localStorageProviderList = uiHelper.getLocalStorage(`${CACHE_KEY.GAME_PROVIDER_TYPE}_${uiHelper.getPlatform()}_${uiHelper.getCurrency()}`).find(x => x.type == type)
      return typeof localStorageProviderList === 'undefined'
        ? []
        : localStorageProviderList.providers.map(function(a) {
            return {
              text: a.providerCode.toUpperCase(),
              value: a.providerCode.toUpperCase()
            }
          })
    }
  },
  created() {
    console.log(this.$route.name)
    this.selectHistoryCat('')
  },
  methods: {
    goToMobileAcc(){
      this.$router.push({ name: this.routeName.MOBILE_ACCOUNT})
    },
    gameTypeOnChanged(type) {
      if (type != 'OVERVIEW') {
        this.selectedGameTypeTranslation = locale.getMessage(`label.${type.type.toLowerCase()}`)
      } else {
        this.selectedGameTypeTranslation = locale.getMessage(`label.all`)
      }
      console.log('mobileHistory gameTypeOnChanged')
    },
    providerFilterOnChanged() {
      console.log('mobileHistory providerFilterOnChanged')
    },
    selectHistoryCat(category, index) {
      if (category != '') {
        this.selectedCategory = category
      } else {
      }
      let currentRoute = this.$route.name
      if (currentRoute.indexOf('betting-history') != -1) {
        this.selectedCategory = this.translatedCategories[0].name
        this.showBetHistoryFilter = true
        this.showTurnoverHistoryFilter = false
        this.showWalletHistoryFilter = false
        this.isBetHistory = true
      } else if (currentRoute.indexOf('turnover-history') != -1) {
        this.selectedCategory = this.translatedCategories[1].name
        this.showBetHistoryFilter = false
        this.showTurnoverHistoryFilter = true
        this.showWalletHistoryFilter = false
        this.isBetHistory = false
      } else if (currentRoute.indexOf('transaction-history') != -1) {
        this.selectedCategory = this.translatedCategories[2].name
        this.showBetHistoryFilter = false
        this.showTurnoverHistoryFilter = false
        this.showWalletHistoryFilter = true
        this.isBetHistory = false
      } else if (currentRoute.indexOf('promo-history') != -1) {
        this.selectedCategory = this.translatedCategories[3].name
      }
    },
    naviToSubHistory(category) {
      this.selectHistoryCat(category.name)
      this.$store.commit('shared/setMobileHIstoryTabOnChange', { selectedTab: category.name, selectedProvider: 'testProvider' })
      console.log(category.name)
    }
  }
}
</script>

<style lang="scss" scoped>
.mobile-filter-col {
  @media (max-width: 400px) {
    flex: 0 0 100% !important;
    max-width: 100% !important;
  }
}
.mobile-history-header {
  background-color: #ffffff;
  color: var(--v-title_color-base);
  min-height: 50px;
  display: flex;
  align-items: center;;
  .mobile-history-header-mid{
    display: flex;
    justify-content: center;
    align-items: center;
    .header-mid-label{
      font-weight: 600;
      font-family: 'Roboto', sans-serif;
    }

  }

  .mobile-history-header-back{
    height: 18px;
    width: 27px;
    padding-left: 8px;
  }
}

.mobile-menu-card-wrapper {
  border-radius: 15px;
  margin: 15px 15px 10px 15px;
}

.mobile-category-menuBtn-promotion {
  justify-content: space-between;
  background-color: #0c8ce9 !important;
  color: #ffffff !important;
  text-transform: none;
}

.mobile-category-menuBtn {
  justify-content: space-between;
  background-color: #f5f5f5;
}

.mobile-menu-card-wrapper-promotion {
  border-radius: 15px;
  margin: 15px 15px 10px 15px;
}
</style>
